var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"auto-animate",rawName:"v-auto-animate"}],staticClass:"cz3__gallery__images"},[_vm._l((_vm.images),function(image){return _c('button',{key:image.url,class:[
            'cz3__gallery__image',
            {
                'cz3__gallery__image--selected': image === _vm.selectedGalleryImage,
            }
        ],attrs:{"title":image.name},on:{"click":function($event){$event.preventDefault();return _vm.selectGalleryImage(image)}}},[_c('span',{staticClass:"cz3__gallery__image__image",style:({
                backgroundImage: _vm.makeImageUrl(image.url)
            }),attrs:{"data-url":image.url}})])}),(!_vm.expanded && _vm.hasMore)?_c('button',{staticClass:"cz3__gallery__view-more",on:{"click":function($event){$event.preventDefault();return _vm.expand.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('V3_VIEW_MORE')))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }